module.exports = __webpack_public_path__ + "static/media/icon-location-warning.e33ac1a3.svg";